import { render, staticRenderFns } from "./DetailsFlexy.vue?vue&type=template&id=2449ef66"
import script from "./DetailsFlexy.vue?vue&type=script&lang=js"
export * from "./DetailsFlexy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports